import { createFileRoute } from '@tanstack/react-router';

// Holds the tab's URL in the overview frame, which hands it back to the embedded app until the
// tab migrates and claims it.
export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/sent/$deliveryId',
)({
  component: () => null,
});
